module.exports = __webpack_public_path__ + "static/img/质量证书.b0c6876.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhengjian/paixu/质量证书.jpg
// module id = M/gk
// module chunks = 6